import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, CircularProgress, Typography, TextField } from '@mui/material';

function CustomSelect({ 
    label, 
    name, 
    options = [], 
    formik, 
    isLoading = false, 
    value = null,
    error = null 
}) {
    if (isLoading) {
        return (
            <TextField
                fullWidth
                variant="outlined"
                size="small"
                label={label}
                InputProps={{
                    endAdornment: <CircularProgress color="inherit" size={20} />,
                }}
            />
        );
    }

    if (error) {
        console.error('Error fetching options:', error);
        return (
            <Typography>{error.message}</Typography>
        );
    }

    return (
        <FormControl fullWidth>
            <InputLabel sx={{pb: 8}} id={`${name}-select-label`}>{label}</InputLabel>
            <Select
                labelId={`${name}-select-label`}
                id={name}
                name={name}
                label={label}
                size="small"
                fullWidth
                error={formik.touched[name] && Boolean(formik.errors[name])}
                value={value || formik.values[name] || ''}
                onChange={(event) => {
                    formik.setFieldValue(name, event.target.value);
                }}
            >
                {options.map((option, index) => (
                    <MenuItem key={index} value={option}>
                        {option}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default CustomSelect;